module.exports = __webpack_public_path__ + "static/stephanie_bodet-b7b47713f98f7e80a899767621bb680e.jpg";